/* eslint-disable @typescript-eslint/no-explicit-any */
import { DevModuleType, DevModule } from '@ipreo/northstar';
import { LoadChildrenCallback } from '@angular/router';

import * as demoAppPackage from '../../../../libs/demo-app/package.json';
import * as demoCardPackage from '../../../../libs/demo-card/package.json';
import * as workbenchPackage from '../../../../libs/workbench/package.json';

export function createDevModule(
  packageMeta: any,
  path: string,
  moduleType: DevModuleType,
  loadChildren: LoadChildrenCallback
): DevModule {
  return {
    moduleType: moduleType,
    path: path,
    loadChildren,
    manifest: {
      name: packageMeta.name,
      version: packageMeta.version,
      ...packageMeta.nmp,
    },
  };
}

export const devModules = [
  createDevModule(demoAppPackage, 'demo-app/:id', DevModuleType.route, () =>
    import('@ipreo/demo-app').then((m) => m.DemoAppModule)
  ),
  createDevModule(workbenchPackage, 'workbench', DevModuleType.route, () =>
    import('@ipreo/workbench').then((m) => m.WorkbenchModule)
  ),
  createDevModule(demoCardPackage, 'demo-card', DevModuleType.component, () =>
    import('@ipreo/demo-card').then((m) => m.DemoCardComponent)
  ),
];
